import Icon, {IIconProps} from './Icon';

export type {IIconProps};
export default Icon;
